import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import externalsGreenPointActions from "../../../redux/actions/externalsGreenPoint";
import groupsActions from "../../../redux/actions/groups";

export default function Search() {
  const [search, setSearch] = useState("");
  const externalGreenPoint = useSelector((state) => state.externalGreenPoint);
  const dispatch = useDispatch();

  useEffect(
    () => setSearch(externalGreenPoint.search),
    [externalGreenPoint.search]
  );

  const handleSubmit = () => {
    if (externalGreenPoint.selector === "GREENPOINTS") {
      dispatch(externalsGreenPointActions.setSearch({ search }));
    } else {
      dispatch(groupsActions.setSearch({ search }));
    }
  };
  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder={
            externalGreenPoint.selector === "GREENPOINTS"
              ? "nombre, grupo"
              : "grupo"
          }
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40, marginTop: 3 }}
          onClick={() => handleSubmit()}
          startIcon={<SearchIcon />}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
